import type { ReactNode } from 'react';
import type { CSSProperties } from 'react';
import { create } from 'zustand';

export type PopupTypeT = 'confirm' | 'alert';

export type PopupThemeT = 'positive' | 'negative' | 'neutral';

export type PopupOptionT<T = any> = {
  popupTheme: PopupThemeT;
  type: PopupTypeT;
  title: string;
  message?: string | ReactNode;
  confirmText?: string;
  cancelText?: string;
  style?: CSSProperties;
  dimStyle?: CSSProperties;
  useBack?: boolean;
  onConfirm?: (data?: T) => void;
  onCancel?: () => void;
  // 상태를 가진 컨텐츠를 렌더링하는 함수
  renderContent?: (handlers: { onDataChange: (data: T) => void }) => ReactNode;
  // confirm 시 데이터를 가져오는 함수
  getConfirmData?: () => T;
};

type State = {
  popup: PopupOptionT<any> | null;
};

type Action = {
  setPopup: (popup: PopupOptionT | null) => void;
  initPopupStore: () => void;
};

const initialState: State = {
  popup: null,
};

const usePopupStore = create<State & Action>((set) => ({
  ...initialState,
  setPopup: (popup) => {
    set((state) => ({
      ...state,
      popup,
    }));
  },
  initPopupStore() {
    set(initialState);
  },
}));

const usePopup = () => usePopupStore((state) => state.setPopup);

const popup = (popup: PopupOptionT | null) => {
  usePopupStore.getState().setPopup(popup);
};

export default usePopupStore;
export { popup, usePopup };
